import React, { useEffect } from "react";
import "@/App.css";
import "@/i18n";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { ShopProvider } from "@/context/ShopContext";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Shop from "@/pages/Shop";
import ProductDetail from "@/pages/ProductDetail";
import Cart from "@/pages/Cart";
import Checkout from "@/pages/Checkout";
import CheckoutSuccess from "@/pages/CheckoutSuccess";
import Wishlist from "@/pages/Wishlist";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import StaticPage from "@/pages/StaticPage";

function App() {
  useEffect(() => { document.title = "BOOM MODE — Premium Leather Goods"; }, []);
  return (
    <div className="App">
      <ShopProvider>
        <BrowserRouter>
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/shop" element={<Shop />} />
              <Route path="/shop/:category" element={<Shop />} />
              <Route path="/product/:slug" element={<ProductDetail />} />
              <Route path="/cart" element={<Cart />} />
              <Route path="/checkout" element={<Checkout />} />
              <Route path="/checkout/success" element={<CheckoutSuccess />} />
              <Route path="/wishlist" element={<Wishlist />} />
              <Route path="/about" element={<StaticPage page="about" />} />
              <Route path="/shipping" element={<StaticPage page="shipping" />} />
              <Route path="/returns" element={<StaticPage page="returns" />} />
              <Route path="/privacy" element={<StaticPage page="privacy" />} />
              <Route path="/terms" element={<StaticPage page="terms" />} />
              <Route path="/contact" element={<StaticPage page="contact" />} />
              <Route path="/faq" element={<StaticPage page="faq" />} />
            </Route>
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminDashboard />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </ShopProvider>
    </div>
  );
}

export default App;
